import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[1.2fr,1fr] gap-6">
        {/* Left Card - Coral */}
        <div className="bg-coral rounded-[2.5rem] p-12 relative overflow-hidden">
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 mb-8">
              <span className="bg-yellow-400 text-navy text-xs font-bold px-3 py-1 rounded-full">
                Review Standees
              </span>
              <span className="text-sm font-medium text-gray-700">Simple, Smart, Effective</span>
              <ArrowRight className="w-4 h-4 text-gray-700" />
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-8">
              Boost Your<br />
              Business<br />
              Reviews<br />
              Effortlessly!
            </h1>
            
            <Button 
              onClick={() => navigate('/shop')}
              className="bg-gray-800 hover:bg-gray-900 text-white rounded-full px-8 py-6 text-base font-medium inline-flex items-center gap-2"
            >
              Get your standee today
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>

        {/* Right side */}
        <div className="space-y-6">
          {/* Yellow Card with GIF */}
          <div className="bg-yellow-custom rounded-[2.5rem] p-6 min-h-[240px] relative overflow-hidden">
            <div className="flex items-center justify-center h-full">
              <img 
                src="https://customer-assets.emergentagent.com/job_replica-labs/artifacts/ubx5m78q_NFC_Yellow%20BG.gif"
                alt="NFC Review Standee Demo"
                className="w-full max-w-xs h-auto object-contain"
              />
            </div>
          </div>

          {/* Purple Badge */}
          <div className="bg-purple-custom rounded-[2rem] p-6">
            <h3 className="text-2xl font-bold text-navy mb-3">
              A simple Tap<br />
              is all it takes.
            </h3>
            <p className="text-sm text-gray-700 mb-4">
              Ask Customers to Tap our devices before they leave, collect real reviews in seconds and be No. 1 on Google.
            </p>
            <Button 
              onClick={() => navigate('/shop')}
              className="bg-navy text-white hover:bg-navy/90 rounded-full px-6 py-3 inline-flex items-center gap-2 text-sm font-semibold"
            >
              Shop Products
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};
